import { StrictMode } from "react";

import { App as AntdApp, ConfigProvider } from "antd";
import jaJP from "antd/lib/locale/ja_JP";
import ReactDOM from "react-dom/client";
import { ToastContainer } from "react-toastify";

import App from "./App";
import "./index.css";
import ReactQueryProvider from "./providers/ReactQueryProvider";
import reportWebVitals from "./reportWebVitals";
import "./utils/datetime/dayjsConfig";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <StrictMode>
    <ConfigProvider
      locale={jaJP}
      button={{ autoInsertSpace: false }}
      theme={{
        token: {
          colorBgContainerDisabled: "#f5f5f5"
        }
      }}
    >
      <AntdApp>
        <ToastContainer />
        <ReactQueryProvider>
          <App />
        </ReactQueryProvider>
      </AntdApp>
    </ConfigProvider>
  </StrictMode>
);

reportWebVitals();
